import React from 'react';
import { useAuth } from '../../context/AuthContext';
import Sidebar from '../../components/Sidebar';
import ProfileDropdown from '../../components/ProfileDropdown';
import ProgressReportCard from '../../components/ProgressReportCard';

const ParentProgressReports = () => {
  const { user } = useAuth();

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 overflow-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-800">📈 Progress Report</h1>
              <p className="text-gray-500 mt-1">Academic performance and attendance summary</p>
            </div>
            <ProfileDropdown />
          </div>

          {user?.studentId ? (
            <ProgressReportCard studentId={user.studentId} editable={false} accentColor="indigo" />
          ) : (
            <div className="bg-white rounded-xl shadow-lg p-10 text-center text-gray-400">No child linked to your account</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParentProgressReports;
